import React from 'react';
import { Box } from '@mui/material';
import image from '../../../assets/CobbleStoneBanner.jpeg';

const CobbleStoneBanner = () => {
    return (
        <Box>
            <Box
                sx={{
                    position: 'relative',
                    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${image})`,
                    backgroundSize: 'fit',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    height: '500px',
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white',
                    textAlign: 'center',
                }}
            />

        </Box>
    );
};

export default CobbleStoneBanner; 
